import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { Country } from '~/Api/Country';
import { ApplicationState } from '~/Store';
import Autocomplete, { Option } from '~/UI/Autocomplete/Autocomplete';

import styles from './styles.less';

interface OwnProps {
	value: string;
	countries: Country[];
}

const mapOptions = memoizeOne((countries: Country[]): Option[] => {
	return countries.map((country) => ({
		id: country.alpha2,
		title: country.name,
		country,
	}));
});

const filterOptions = memoizeOne((options: Option[], query: string): Option[] => {
	const lowerCasedQuery = query.toLowerCase();
	const filteredOptions = options.filter((option) => option.title.toLowerCase().startsWith(lowerCasedQuery));
	filteredOptions.sort((a, b) => a.title.localeCompare(b.title));
	return filteredOptions;
});

function mapStateToProps(
	state: ApplicationState,
	{ value, countries }: OwnProps
): {
	options: Option[];
	styles: typeof styles;
} {
	return {
		options: filterOptions(mapOptions(countries), value),
		styles,
	};
}

export default connect(mapStateToProps)(Autocomplete);
